<template>
  <div id="ExistingChild">
    <v-layout class="mt-2 mb-3">
      <v-flex>
        <v-btn fab absolute left class="ml-3 pf-btn-fab" @click="backToListing">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 class="text-xs-right">
        <v-btn class="pf-btn pf-btn-grey border-radius-10 box-shadow-none" @click="backToListing">
          <v-icon size="16" class="pr-1">cancel</v-icon>
          <div>Cancel</div>
        </v-btn>
        <v-btn class="pf-btn pf-bg-teal border-radius-10 box-shadow-none" @click="addSelectedChildren" :disabled="!selectedChildren.length">
          <v-icon size="16" class="pr-1">check_circle</v-icon>
          <div>Submit</div>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout wrap row class="px-2 my-4">
      <v-flex sm4 class="px-2">
        <v-select 
          class="filter_left"
          v-model="filterChildType" 
          label="Filter by ChildType"
          :items="[...['All'], ...childTypeList]" 
          @change="filterByChildType">
          <template v-slot:item="data">
            <template>
              <v-list-tile-content>
                <v-list-tile-title>{{ data.item }}</v-list-tile-title>
              </v-list-tile-content>
            </template>
          </template>
        </v-select>
      </v-flex>
      <v-flex sm4 class="px-2">
        <v-select 
          class="filter_left"
          v-model="filterState" 
          label="Filter by State"
          :items="[...['All'], ...childStates]" 
          @change="filterByState">
          <template v-slot:item="data">
            <template>
              <v-list-tile-content>
                <v-list-tile-title>{{ data.item }}</v-list-tile-title>
              </v-list-tile-content>
            </template>
          </template>
        </v-select>
      </v-flex>
      <!-- <v-flex sm4 class="px-2">
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search by Name"
        ></v-text-field>
      </v-flex> -->
    </v-layout>
    <v-flex class="mx-4">
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="childList"
        item-value="name"
        :search="search"
        no-data-text="No results, Search for your children"
        :pagination.sync="pagination" 
        select-all="teal"
        class="pf-data-table"
      >
      <template v-slot:headers="props">
          <tr>
            <th width="50px">
                <v-checkbox
                :input-value="props.all"
                :indeterminate="props.indeterminate"
                primary
                hide-details
                @click.stop="toggleAll"
              ></v-checkbox>
            </th>
            <th
              v-for="header in props.headers"
              :key="header.text"
              aria-sort="none"
              class="text-xs-left"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr :class="{ 'pf-row-highlighted': props.item.agency }">
          <td :active="props.selected">
            <v-checkbox
              :input-value="props.selected"
              color="teal"
              class="mt-3"
              @change="toggleSelection($event, props.item)"
            ></v-checkbox>
          </td>
            <td width="150">
              <v-layout justify-left>
              {{ props.item.name }}
              </v-layout>
            </td>
            <td>
              {{ props.item.type }}
            </td>
          
            <td>{{ props.item.agency && props.item.agency.address && props.item.agency.address.length ? (props.item.agency.address[0].state && props.item.agency.address[0].state.name ? props.item.agency.address[0].state.name : '--') : '--' }}</td>
            <td>
              {{ props.item.status.status }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </div>
</template>
<script>
/* global session config store moment */
import { getOne, getCollection, update, create, formatDate, requestExternal } from '../../helpers/helpers';
import swal from 'sweetalert2';
import appHistory from '../History/list';
import { mapGetters } from 'vuex';

export default {
  components: { appHistory },
  data: () => ({
    entity: 'ChildManagement',
    waitingPicker: [],
    config: config,
    search: '',
    filterStatus: 'All',
    filterChildType: 'All',
    filterState: 'All',
    // filterPlacementStatus: 'All',
    childList: [],
    searchResults: [],
    query: {
      child: ''
    },
    displayChildrenList: [],
    selected: [],
    childStates: [],
    childTypeList: ['Individual', 'Group'],
    statusList: ['Active', 'On Hold', 'Family Matched'],
    headers: [
      { text: 'Name', value: 'name', align: 'left' },
      { text: 'Type', value: 'type', align: 'left' },
      { text: 'Display Locations', value: 'display_locations', align: 'left' },
      { text: 'Status', value: 'status.status', align: 'left' },
    ],
    pagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: ''
    },
    historyPagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: ''
    },
    countArr: [],
    selectedChildren: []
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    Agency: {
      set (value) {
        store.commit('setAgency', value);
      },
      get () {
        return store.state.Agency;
      }
    },
    State: {
      get () {
        return store.state.State;
      },
      set (value) {
        store.commit('setState', value);
      }
    },
    AgencyList: {
      set (value) {
        store.commit('setAgencyList', value);
      },
      get () {
        return store.state.AgencyList;
      }
    },
    ChildrenJSONData: {
      get () {
        return store.state.ChildrenJSONData;
      },
      set (value) {
        store.commit('setChildrenJSONData', value);
      }
    }
  },
  watch: {
    displayChildrenList (value) {
      this.displayChildrenList = value;
      this.childList = this.displayChildrenList;
      this.query.child = '';
    }
  },
  async created () {
    window.getApp.$emit('pageSubHeader', 'Add To Display');
    this.initialize();
    this.initializeAgencyList();
    this.initializeState();
  },

  methods: {
    formatDateString (date) {
      if (!date) return '';
      let dateString = date.substr(0, 10);
      const [year, month, day] = dateString.split('-');
      return `${month}/${day}/${year}`;
    },
    async initializeAgencyList () {
      if (!this.AgencyList.length) {
        let where = { /* _id: { $ne: this.Agency.id }, */ is_admin: false };
        let attributes = 'name,nickname,email,createdAt,_id,mapping_id';
        let populate = [{ path: 'human', select: '_id user' }];
        let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            store.commit('setAgencyList', data);            
          }
        }
      }
    },
    async initialize () {
      if (!this.displayChildrenList.length) {
        const existingChildren = this.Agency.other_children.filter(child => child.child).map(child => child.child);
        let populate = [{ path: 'child.child', populate: { path: 'human', populate: { path: 'user', select: 'username' }}}, { path: 'agency', select: 'name address', populate: { path: 'address.state', select: 'name' }}];
        const agencyStates = this.Agency.address.length ? this.Agency.address.filter(a => a.state && a.state.id).map(a => a.state.id) : [];
        let where = {
          agency: { $ne: this.Agency._id },
          _id: { $nin: existingChildren },
          $or: [
            { placement: 'anyWhere' },
            { placement: { $in: ['inState', 'selectedStates'] }, display_on_states: { $in: agencyStates }}
          ]
        };
          
        if (['agency', 'caseworker'].indexOf(session.role()) > -1 && !this.Agency.is_super_admin) {
          where['status.status'] = 'Active';
        }
        let sort = { 'createdAt': -1 };
        let { error, data } = await getCollection('ChildGroup', true, 0, populate, where, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length) {
            this.displayChildrenList = data;
          }
        }
      }
      this.childList = this.displayChildrenList;
    },
    filterByState () {
      if (this.filterState === 'All') {
        this.childList = this.query.child && this.query.child !== '' ? this.searchResults : this.displayChildrenList;
      } else {
        this.childList = this.displayChildrenList.filter(child => child.agency.address[0].state.name === this.filterState);
      }
    },
    filterByChildType () {
      if (this.filterChildType === 'All') {
        this.childList = this.query.child && this.query.child !== '' ? this.searchResults : this.displayChildrenList;
      } else if (this.query.child && this.query.child !== '') {
        this.childList = this.searchResults.filter(child => child.type === this.filterChildType);
      } else {
        this.childList = this.displayChildrenList.filter(child => child.type === this.filterChildType);
      }

    },
    async initializeState () {
      if (!this.State.length) {
        let sort = { name: 1 };
        let { error, data } = await getCollection('State', true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.State = data;
            data.forEach(element => {
              this.childStates.push(element.name);
            });
          }
        }
      }
    },
    backToListing () {
      this.$router.push({ path: '/children', query: { requestFrom: 'update' }});
    },
    toggleAll () {
      if (this.selected.length) {
        this.selected = [];
        this.selectedChildren = [];
      } else {
        this.selected = this.childList.slice();
        this.selectedChildren = this.childList.map(x => {
          return { child: x._id, createdAt: Date(), status: 'Enabled' };
        });
      }
    },
    async toggleSelection (checked, child) {
      const index = this.selectedChildren.findIndex(x => x.child.toString() === child._id.toString());
      if (checked && index === -1) {
        this.selectedChildren.push({ child: child._id, createdAt: Date(), status: 'Enabled' });
      } else if (index > -1) {
        this.selectedChildren.splice(index, 1);
      }
    },
    async addSelectedChildren () {
      if (!this.selectedChildren.length) {
        return;
      }
      let updateId = this.Agency._id;
      let updateItem = this.Agency;
      updateItem.other_children = [...updateItem.other_children, ...this.selectedChildren];
      updateItem.updated_from = 'childBadge';
      let { error, data, status } = await update('Agency', updateItem, updateId);
      if (error) {
        console.log('error', error);
      } else {
        const newlyAddedIds = this.selectedChildren.map(x => x.child);
        this.displayChildrenList = this.displayChildrenList.filter(child => newlyAddedIds.indexOf(child._id) === -1);
        swal.fire({
          type: 'success',
          title: `Selected ${this.selectedChildren.length === 1 ? 'child was' : 'children were'} added.`,
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
            this.backToListing();
          }
        });
      }
    }
  }
};
</script>
<style scoped>
.text-right {
  text-align: right !important;
}

#childManagement >>> .v-select__selection {
    width: 100%;
    justify-content: center;
    padding-left: 10px;
}

#childManagement >>> .filter_left .v-select__selection {
  justify-content: start !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/Children/selectExistingChildren.vue